export const TAU = Math.PI * 2;

export function clamp(x: number, lo: number, hi: number): number {
  return x < lo ? lo : x > hi ? hi : x;
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function smoothstep(e0: number, e1: number, x: number): number {
  const t = clamp((x - e0) / (e1 - e0), 0, 1);
  return t * t * (3 - 2 * t);
}

/** Exponential approach factor for a time constant, frame-rate independent. */
export function damp(dt: number, timeConstant: number): number {
  return timeConstant <= 0 ? 1 : 1 - Math.exp(-dt / timeConstant);
}
